import { Injectable } from '@angular/core';
import { CoolHttp } from '@angular-cool/http';
import { CampaignFullDTO, CampaignId, CampaignMinimumDTO } from '../../../../../common/dto/campaigns.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { FileUploadRequestUtils } from '../utils/file-upload-request.utils';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';
import { Observable, Subject } from 'rxjs';
import { CacheState, CacheStateUpdater } from '@coool/cachestate';
import { filter } from 'rxjs/operators';
import { filterDefined } from '../utils/observable.utils';

const campaignCacheUpdater = new Subject<string | void>();

@Injectable()
export class CampaignsService {
  constructor(private _http: CoolHttp) {}

  public async getAvailableCampaignsAsync(): Promise<CampaignMinimumDTO[]> {
    return await this._http.getAsync(ServerUrls.Campaigns.children.Get.absoluteUrl);
  }

  @CacheState({
    maxAgeMS: 5 * MINUTE_IN_MILLISECONDS,
    cacheKey: {
      generator: args => `campaign_${args[0]}`,
    },
    updatedObservable: campaignCacheUpdater.pipe(filterDefined()),
  })
  public getCampaignByIdCACHED(campaignId: CampaignId): Observable<CampaignFullDTO> {
    return this._http.getObservable(
      ServerUrls.Campaigns.children.GetById.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.GetById.params.campaignId]: campaignId,
      }),
    );
  }

  @CacheStateUpdater({
    cacheKeyGenerator: args => {
      const campaign: CampaignFullDTO = args[0];

      return campaign.id ? `campaign_${campaign.id}` : undefined;
    },
    updatedNotifier: campaignCacheUpdater,
  })
  public async upsertCampaignAsync(campaign: CampaignFullDTO): Promise<CampaignFullDTO> {
    const formData = FileUploadRequestUtils.createRequestForm('campaign', campaign, [
      {
        name: 'image',
        resolver: _ => _.image,
      },
    ]);

    return await this._http.postAsync(ServerUrls.Campaigns.children.Upsert.absoluteUrl, formData);
  }
}
